import { Component, computed, inject, signal } from '@angular/core';
import { QrCodeService, QrMaintenanceTimerDto } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { ActivatedRoute, Router } from '@angular/router';
import { qrBuildingContext } from '@services/qr-building-context.service';

@Component({
  standalone: false,
  selector: 'wr-qr-code-maintenance-timer-page',
  templateUrl: './qr-code-maintenance-timer-page.component.html',
  styleUrls: ['./qr-code-maintenance-timer-page.component.scss'],
})
export class QrCodeMaintenanceTimerPageComponent {

  private readonly qrCodeService = inject(QrCodeService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  readonly context = qrBuildingContext();
  readonly searchText = signal<string>('');

  readonly maintenanceTimers = asyncComputed(() => {
    const buildingSectionId = this.context.sectionId();
    if (!buildingSectionId || !this.context.session()?.canViewMaintenanceTimers) {
      return [];
    }
    return this.qrCodeService.findAllAssignedMaintenanceTimersByBuildingSectionId(buildingSectionId);
  }, undefined);

  readonly filteredMaintenanceTimers = computed(() => {
    const searchText = this.searchText().toLowerCase();
    const maintenanceTimers = this.maintenanceTimers() ?? [];

    if (!searchText) return maintenanceTimers;

    return maintenanceTimers.filter(maintenanceTimer =>
      maintenanceTimer.buildingEquipmentName.toLowerCase().includes(searchText),
    );
  });

  searchTextChange(search: string): void {
    this.searchText.set(search);
  }

  daysLeft(timer: QrMaintenanceTimerDto): number {
    if (!timer?.nextDate) return 0;

    const nextDate = new Date(timer.nextDate);
    const currentDate = new Date();
    const diffTime = nextDate.getTime() - currentDate.getTime();

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  finishMaintenanceTimer(timer: QrMaintenanceTimerDto): void {
    this.router.navigate(['finish', timer.id], { relativeTo: this.route });
  }
}
